// Region codes must match backend country_region(): AT, DE, CH, EU, WORLD
export const REGIONS = [
  { code: "AT", label: "Österreich" },
  { code: "DE", label: "Deutschland" },
  { code: "CH", label: "Schweiz" },
  { code: "EU", label: "EU (übrige Länder)" },
  { code: "WORLD", label: "Weltweit (Rest)" },
];

const EU = ["BE", "BG", "CZ", "DK", "EE", "IE", "GR", "ES", "FR", "HR", "IT", "CY",
  "LV", "LT", "LU", "HU", "MT", "NL", "PL", "PT", "RO", "SI", "SK", "FI", "SE"];

export function countryRegion(code) {
  const c = (code || "").toUpperCase();
  if (c === "AT" || c === "DE" || c === "CH") return c;
  if (EU.includes(c)) return "EU";
  return "WORLD";
}

// Dropdown list; codes match ISO-3166 alpha-2 where sensible.
export const COUNTRIES = [
  { code: "AT", name: "Österreich" },
  { code: "DE", name: "Deutschland" },
  { code: "CH", name: "Schweiz" },
  { code: "BE", name: "Belgien" },
  { code: "BG", name: "Bulgarien" },
  { code: "HR", name: "Kroatien" },
  { code: "CY", name: "Zypern" },
  { code: "CZ", name: "Tschechien" },
  { code: "DK", name: "Dänemark" },
  { code: "EE", name: "Estland" },
  { code: "FI", name: "Finnland" },
  { code: "FR", name: "Frankreich" },
  { code: "GR", name: "Griechenland" },
  { code: "HU", name: "Ungarn" },
  { code: "IE", name: "Irland" },
  { code: "IT", name: "Italien" },
  { code: "LV", name: "Lettland" },
  { code: "LT", name: "Litauen" },
  { code: "LU", name: "Luxemburg" },
  { code: "MT", name: "Malta" },
  { code: "NL", name: "Niederlande" },
  { code: "PL", name: "Polen" },
  { code: "PT", name: "Portugal" },
  { code: "RO", name: "Rumänien" },
  { code: "SK", name: "Slowakei" },
  { code: "SI", name: "Slowenien" },
  { code: "ES", name: "Spanien" },
  { code: "SE", name: "Schweden" },
  { code: "WORLD", name: "Anderes Land (Weltweit)" },
];
